// extracted by mini-css-extract-plugin
export default {"pt_1":"Company_pt_1__-SOk5","ml_2":"Company_ml_2__MnM-L","hide":"Company_hide__QFaEn","show":"Company_show__fH4nO"};